/**
 * The api parks an MCP client's authorize request and sends the person here to
 * sign in; `next` is where it wants them back. A path on this origin only, so
 * the parameter cannot be used to bounce someone somewhere else.
 */
export function nextAfterSignIn(): string | null {
  const next = new URLSearchParams(window.location.search).get('next');
  if (next === null || !next.startsWith('/') || next.startsWith('//')) return null;
  return next;
}
